import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, TrendingUp, Users, Calendar } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export default function MobileCRMOpportunityDetailPage() {
  const { oppId } = useParams();
  const navigate = useNavigate();
  const [opp, setOpp] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/crm/opportunities`).then(r => {
      const found = (r.data || []).find(o => (o.opportunity_id || o.id) === oppId);
      setOpp(found || null);
    }).catch(() => {}).finally(() => setLoading(false));
  }, [oppId]);

  if (loading) return <div className="mobile-page"><div className="mobile-loading"><div className="mobile-spinner" /></div></div>;
  if (!opp) return <div className="mobile-page"><button className="mobile-back-btn" onClick={() => navigate(-1)}><ArrowLeft size={18} /> Back</button><div className="mobile-empty-state"><p>Opportunity not found</p></div></div>;

  return (
    <div className="mobile-page">
      <button className="mobile-back-btn" onClick={() => navigate('/mobile/crm/opportunities')}><ArrowLeft size={18} /> Opportunities</button>
      <div className="mobile-detail-section" style={{ textAlign: 'center', paddingTop: 20, paddingBottom: 20 }}>
        <span className="mobile-status-badge scheduled" style={{ fontSize: 12 }}>{opp.stage || 'N/A'}</span>
        <div style={{ fontSize: 20, fontWeight: 700, color: '#1c1c1e', marginTop: 10 }}>{opp.customer_name || opp.name}</div>
        <div style={{ fontSize: 14, color: '#8e8e93', marginTop: 4 }}>{opp.name || opp.description}</div>
      </div>
      <div className="mobile-kpi-row">
        <div className="mobile-kpi-card green"><div className="mobile-kpi-label">Revenue</div><div className="mobile-kpi-value" style={{ fontSize: 20 }}>${((opp.revenue || opp.total_revenue || opp.value || 0) / 1000).toFixed(0)}k</div></div>
        <div className="mobile-kpi-card blue"><div className="mobile-kpi-label">Probability</div><div className="mobile-kpi-value" style={{ fontSize: 20 }}>{opp.probability || opp.close_probability || 0}%</div></div>
      </div>
      <div className="mobile-detail-section">
        <div className="mobile-detail-section-title">Details</div>
        <div className="mobile-detail-row"><span className="mobile-detail-label">Customer</span><span className="mobile-detail-value">{opp.customer_name || 'N/A'}</span></div>
        <div className="mobile-detail-row"><span className="mobile-detail-label">Stage</span><span className="mobile-detail-value">{opp.stage || 'N/A'}</span></div>
        {opp.description && <div className="mobile-detail-row"><span className="mobile-detail-label">Description</span><span className="mobile-detail-value" style={{ maxWidth: '60%', textAlign: 'right' }}>{opp.description}</span></div>}
        {opp.expected_close_date && <div className="mobile-detail-row"><span className="mobile-detail-label">Close Date</span><span className="mobile-detail-value">{opp.expected_close_date}</span></div>}
        {opp.owner && <div className="mobile-detail-row"><span className="mobile-detail-label">Owner</span><span className="mobile-detail-value">{opp.owner}</span></div>}
      </div>
      {opp.line_items && opp.line_items.length > 0 && (
        <div className="mobile-detail-section">
          <div className="mobile-detail-section-title">Line Items ({opp.line_items.length})</div>
          {opp.line_items.map((li, i) => (
            <div key={i} className="mobile-detail-row">
              <span className="mobile-detail-label">{li.item_name || li.product_name || `Item ${i+1}`}</span>
              <span className="mobile-detail-value">{li.quantity || ''} {li.unit || ''}{li.revenue ? ` · $${(li.revenue/1000).toFixed(0)}k` : ''}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
